var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmenia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5136_5160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 10.9997C22 9.65414 21.758 8.36521 21.3158 7.1736L11 6.69531L0.684191 7.17355C0.242043 8.36521 0 9.65414 0 10.9997C0 12.3452 0.242043 13.6341 0.684191 14.8257L11 15.304L21.3158 14.8258C21.758 13.6341 22 12.3452 22 10.9997Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22.0001C15.7296 22.0001 19.7616 19.015 21.3158 14.8262H0.684204C2.23843 19.015 6.2704 22.0001 11 22.0001Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.684204 7.17393H21.3159C19.7616 2.98513 15.7296 0 11 0C6.2704 0 2.23843 2.98513 0.684204 7.17393Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5136_5160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmenia);
export default __webpack_public_path__ + "static/media/armenia.4e53896dd07ac4a991649b28685b6cdb.svg";
export { ForwardRef as ReactComponent };